import Grid from "@mui/material/Grid2";
import { Box, Divider } from "@mui/material";
import React from "react";

import { TabSessionStorageResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { FieldSpacing } from "../../styles/style";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue } from "../../../../utils";
import { Title } from "../../styles/OrderingPhysician";
import { colors } from "../../../../styles/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import { TypographyBox } from "../../../../app/common/TextLabel";

export interface PropsFromState {
  tabSessionStorage: TabSessionStorageResponse;
}
type AllProps = PropsFromState;

const PhysicianDetails: React.FC<AllProps> = ({ tabSessionStorage }) => {

  return (
    <Box>
      {[
      {
        title: "Primary Care Physician",
        path: "response.physicianDetails.primaryPhysician",
      },
      {
        title: "Ordering Physician",
        path: "response.physicianDetails.orderingPhysician",
      },
      ].map(({ title, path }, idx) => (
      <React.Fragment key={title}>
        <Box sx={Title} m={idx === 0 ? "0 0 1rem 2rem" : "1rem 0 1rem 2rem"}>
        {TypographyBox(title, colors.fonts[20], fontWeight[5])}
        </Box>
        <Grid container sx={flexRow}>
        {[
          { label: "Physician Name:", field: "physicianName" },
          { label: "NPI:", field: "physicianNpiId" },
          { label: "Tax ID:", field: "taxId" },
          { label: "Phone:", field: "phoneNo" },
          { label: "Fax:", field: "fax" },
          { label: "Street 1:", field: "streetName1" },
          { label: "Street 2:", field: "streetName2" },
          { label: "City:", field: "city" },
          { label: "State:", field: "physicianState" },
          { label: "County:", field: "county" },
          { label: "Zipcode:", field: "zipCode" },
        ].map(({ label, field }) => (
          <Grid key={label} size={{ xs: 3 }} sx={FieldSpacing}>
          <ReadOnlyField
            label={label}
            value={getValue(tabSessionStorage, `${path}.${field}`)}
          />
          </Grid>
        ))}
        </Grid>
        {idx === 0 && <Divider sx={{ marginY: 0.5, marginX: 2 }} />}
      </React.Fragment>
      ))}
    </Box>
  );
};

export default PhysicianDetails;
